import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Branding } from '../../../../../../pages/project/settings/Branding';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/branding')({
  component: BrandingRoute,
});

function BrandingRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <Branding projectId={project_id} portalApiClient={apiClient} />;
}
